import { Component } from '@theme/component';

const UNITS = ['cm', 'in'];

/**
 * The cm / in switch over the Hajjo size tables (snippets/hajjo-size-guide.liquid).
 *
 * Both figures are rendered in Liquid, so the tables read in centimetres with no script.
 * This component only flips `data-unit` on its root and keeps `aria-pressed` on the two
 * buttons in step. Every page load opens in centimetres, the unit of the owner's size guide;
 * a switch moves every set of tables on the page together, so the drawer and the page
 * never disagree.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} units - The cm and in buttons.
 *
 * @extends {Component<Refs>}
 */
class HajjoSizeUnits extends Component {
  /**
   * Switches every size table on the page to a unit.
   * Called from the buttons as `on:click="/setUnit/cm"` and `on:click="/setUnit/in"`.
   *
   * @param {string} unit - 'cm' or 'in'.
   */
  setUnit(unit) {
    if (!UNITS.includes(unit)) return;

    for (const element of document.querySelectorAll('hajjo-size-units')) {
      if (element instanceof HajjoSizeUnits) element.applyUnit(unit);
    }
  }

  /**
   * Shows one unit in this set of tables.
   *
   * @param {string} unit - 'cm' or 'in'.
   */
  applyUnit(unit) {
    if (!UNITS.includes(unit)) return;

    this.dataset.unit = unit;

    for (const button of this.refs.units ?? []) {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    }
  }
}

if (!customElements.get('hajjo-size-units')) customElements.define('hajjo-size-units', HajjoSizeUnits);
